var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgGmail = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  width: "1em",
  height: "1em",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4caf50",
  d: "m45 16.2-5 2.75-5 4.75V40h7a3 3 0 0 0 3-3V16.2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1e88e5",
  d: "m3 16.2 3.614 1.71L13 23.7V40H6a3 3 0 0 1-3-3V16.2z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#e53935",
  d: "m35 11.2-11 8.25-11-8.25-1 5.8 1 6.7 11 8.25 11-8.25 1-6.7z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#c62828",
  d: "M3 12.298V16.2l10 7.5V11.2L9.876 8.859A4.298 4.298 0 0 0 3 12.298z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fbc02d",
  d: "M45 12.298V16.2l-10 7.5V11.2l3.124-2.341A4.298 4.298 0 0 1 45 12.298z"
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgGmail);
export default ForwardRef;